module.exports = __webpack_public_path__ + "img/see_no_evil.58f8d47c.png";